import { TextInputFormikPropTypes, TextInputFormikDefaultProps } from '../../Utils/TextInputPropTypes';

export const InputPhonePropTypes = TextInputFormikPropTypes;

export const InputPhoneDefaultProps = TextInputFormikDefaultProps;

export default { InputPhonePropTypes, InputPhoneDefaultProps };
